import type { RSUAsset, ShareAsset } from "~/types/assets.types";

export const calculateStocksYears = (userProduct: ShareAsset) => {
  const stocks = userProduct?.stocksData || [];

  return stocks.map((stock) => {
    const purchaseDate = stock.purchaseDate || "";
    const currentDate = new Date();
    const purchasingDate = new Date(purchaseDate);

    return currentDate.getFullYear() - purchasingDate.getFullYear() || 0;
  });
};


export const calculateRSUsYears = (userProduct: RSUAsset) => {
  const stocks = userProduct?.rsuData || [];

  return stocks.map((stock) => {
    const purchaseDate = stock.grantDate || "";
    const currentDate = new Date();
    const purchasingDate = new Date(purchaseDate);

    return currentDate.getFullYear() - purchasingDate.getFullYear() || 0;
  });
};
